import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";

export const GcpUploadApi = createApi({
  reducerPath: "gcpUploadApi",
  //   http://172.30.30.87:8337/api/upload
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  tagTypes: ["contentFaq"],
  endpoints: (builder) => ({
    uploadContent: builder.mutation({
      query: (data) => {
        return {
          url: `/gcp/upload`,
          method: "POST",
          body: data
        };
      },
      extraOptions: { service: "Utility" }
    })
  })
});

export const { useUploadContentMutation } = GcpUploadApi;
